var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactSelect from 'react-select';
import { styled } from 'styled-components';
import theme from '../../../../../landing/components/core/themes/theme';
var ScSelect = styled.div.withConfig({ displayName: "ScSelect", componentId: "sc-1o8y7cs" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 270px;\n\n  #react-select-2-listbox {\n    z-index: 100;\n  }\n"], ["\n  width: 270px;\n\n  #react-select-2-listbox {\n    z-index: 100;\n  }\n"])));
var selectStyles = {
    control: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: theme.colors.blue60, borderColor: 'transparent', cursor: 'pointer', minHeight: 40, ':hover': {
            borderColor: 'transparent',
            backgroundColor: theme.colors.blue50,
        }, ':focus': {
            borderColor: 'transparent',
            backgroundColor: theme.colors.blue50,
        }, ':active': {
            borderColor: 'transparent',
            backgroundColor: theme.colors.blue50,
        } })); },
    singleValue: function (styles) { return (__assign(__assign({}, styles), { color: theme.colors.white, fontWeight: 'bold', lineHeight: '24px', '--primary': theme.colors.white, '--secondary': theme.colors.blue60 })); },
    indicatorSeparator: function () { return ({
        display: 'none',
    }); },
    dropdownIndicator: function (styles, _a) {
        var selectProps = _a.selectProps;
        return (__assign(__assign({}, styles), { color: theme.colors.white, ':hover': {
                color: theme.colors.white,
            }, transform: selectProps.menuIsOpen ? 'scale(1, -1)' : '' }));
    },
    option: function (styles, _a) {
        var isDisabled = _a.isDisabled, isFocused = _a.isFocused, isSelected = _a.isSelected;
        return __assign(__assign({}, styles), { backgroundColor: (function () {
                if (isSelected)
                    return theme.colors.blue60;
                if (isFocused)
                    return '#E3F2FC';
                return theme.colors.white;
            })(), color: isSelected ? theme.colors.white : theme.colors.black10, cursor: isDisabled ? 'not-allowed' : 'pointer', borderRadius: 8, lineHeight: '24px', '--primary': isSelected ? theme.colors.white : theme.colors.blue60, '--secondary': isSelected ? theme.colors.blue60 : theme.colors.white, ':active': {
                backgroundColor: '#E3F2FC',
            } });
    },
    menuList: function (styles) { return (__assign(__assign({}, styles), { padding: 8, maxHeight: 'auto' })); },
    menu: function (styles) { return (__assign(__assign({}, styles), { boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.17)', marginTop: 0 })); },
};
var Select = function (props) {
    return (_jsx(ScSelect, { children: _jsx(ReactSelect, __assign({}, props, { styles: selectStyles, isSearchable: false, menuShouldScrollIntoView: false, hideSelectedOptions: true, theme: function (rsTheme) { return (__assign(__assign({}, rsTheme), { borderRadius: 8, colors: __assign(__assign({}, rsTheme.colors), { primary: theme.colors.blue60 }) })); } }), void 0) }, void 0));
};
export default Select;
var templateObject_1;
